import React, { Fragment, useCallback, useEffect, useRef, useState } from 'react';
import Pusher from 'pusher-js';
import { GoogleMap, useJsApiLoader, Marker, OverlayView, DirectionsRenderer, Polyline, Circle } from '@react-google-maps/api';
import { handleAsyncCall, toDefaultDateFormat } from 'utils/common';
import { realtimeMapService } from 'services/realtimeMap';
import _, { upperCase } from 'lodash';
import useMain from 'hooks/useMain';
import { rFetchSteps, rFetchWorkflows } from 'store/reducers/comModule';
import { dispatch } from 'store';
import { andersonLocation, areaPointsNear } from '.';
const distanceRequestBase = (google) => ({
  travelMode: google.maps.TravelMode.DRIVING,
  unitSystem: google.maps.UnitSystem.METRIC,
  avoidHighways: false,
  avoidTolls: false
});

const hkEqualsTwoLangs = (lang) => lang.includes('Hong Kong') || lang.includes('香港');
const chinaEqualThreeLangs = (lang) => lang.includes('China') || lang.includes('中國') || lang.includes('中国');

const isConstructor = (x) => {
  try {
    Reflect.construct(String, [], x);
  } catch (e) {
    return false;
  }
  return true;
};

export const useRealtimeGpsMap = () => {
  const mapRef = useRef(null);
  const { upperCaseLang, useSelector } = useMain();
  const [value, setValue] = useState(null);
  const [openVehicleList, setOpenVehicleList] = useState(true);
  const [count, setCount] = useState({});
  // const [mdDistance, setMdDistance] = useState([]);
  const [mapCenter, setMapCenter] = useState({
    lat: 22.302711,
    lng: 114.177216
  });
  const workflows = useSelector((state) => state.comModule.workflows);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  const [isLoading, setIsLoading] = useState(false);

  const [targetVehicle, setTargetVehicle] = useState({});
  const [vehicleList, setVehicleList] = useState([]);
  const [chinaStartToVehicleDirection, setChinaStartToVehicleDirection] = useState();
  const [hongKongStartToVehicleDirection, setHongKongStartToVehicleDirection] = useState();
  const [chinaVehicleToEndDirection, setChinaVehicleToEndDirection] = useState();
  const [chinaStartToEndDirection, setChinaStartToEndDirection] = useState();
  const [hongKongStartToEndDirection, setHongKongStartToEndDirection] = useState();

  const [hongKongVehicleToEndDirection, setHongKongVehicleToEndDirection] = useState();
  const [hongKongVehicleDirection, setHongKongVehicleDirection] = useState();
  const [currentDistrict, setCurrentDistrict] = useState('');
  const [currentVehicleHistories, setCurrentVehicleHistories] = useState([]);
  const [currentLocation, setCurrentLocation] = useState({
    GpsLat: null,
    GpsLong: null
  });

  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY
  });

  // get the duraction and distance from current location to end
  const fetchDistanceMatrix = useCallback(
    async (vehicle) => {
      if (window.google?.maps && isConstructor(window.google.maps.DistanceMatrixService)) {
        const matrixServiceCN = new window.google.maps.DistanceMatrixService();
        const matrixServiceHK = new window.google.maps.DistanceMatrixService();
        //
        //
        const originsCN = _.isEmpty(vehicle?.China) ? [] : [{ lat: vehicle?.China[0]?.lat, lng: vehicle?.China[0]?.lng }];
        const originsHK = _.isEmpty(vehicle?.HongKong) ? [] : [{ lat: vehicle?.HongKong[0]?.lat, lng: vehicle?.HongKong[0]?.lng }];
        const destinationsCN = _.isEmpty(vehicle?.China) ? [] : [{ lat: vehicle?.China[1]?.lat, lng: vehicle?.China[1]?.lng }];
        const destinationsHK = _.isEmpty(vehicle?.HongKong) ? [] : [{ lat: vehicle?.HongKong[1]?.lat, lng: vehicle?.HongKong[1]?.lng }];
        const currentLoc = [{ lat: Number(vehicle?.CurrentLocation?.GpsLat), lng: Number(vehicle?.CurrentLocation?.GpsLong) }];

        const matrixRequestCNFullRoute = {
          origins: originsCN,
          destinations: destinationsCN,
          ...distanceRequestBase(window.google)
        };

        const matrixRequestCNRoute = {
          origins: currentLoc,
          destinations: destinationsCN,
          ...distanceRequestBase(window.google)
        };
        const matrixRequestHKFullRoute = {
          origins: originsHK,
          destinations: destinationsHK,
          ...distanceRequestBase(window.google)
        };
        const matrixRequestHK = {
          origins: currentLoc,
          destinations: destinationsHK,
          ...distanceRequestBase(window.google)
        };

        let geo = {};
        let geoAddress = '';
        let geoDistrict = '';

        if (vehicle?.CurrentLocation?.GpsLat && vehicle.Status !== 'ArrivedSite' && vehicle.Status !== 'SiteAccepted') {
          // const getGeoCode = setTimeout(async () => {
          const Geocoder = new window.google.maps.Geocoder();

          geo = await Geocoder.geocode({
            location: {
              lat: Number(vehicle?.CurrentLocation?.GpsLat),
              lng: Number(vehicle?.CurrentLocation?.GpsLong)
              // lat: 22.548119,
              // lng: 114.072963
            }
          });

          geoAddress = geo?.results[0]?.formatted_address;
          geoDistrict = geo?.results?.slice(-1)[0]?.formatted_address;
          // }, 100);
          // clearTimeout(getGeoCode);
        } else if (vehicle.Status === 'ArrivedSite' || vehicle.Status === 'SiteAccepted') {
          geoAddress = '-';
          geoDistrict = '-';
        }

        // const matrixResponseCNFull = vehicle?.China ? await matrixServiceCN.getDistanceMatrix(matrixRequestCNFullRoute) : '';
        // const fullDurationCN = matrixResponseCNFull?.rows[0]?.elements[0]?.duration?.text;
        // const fullDistanceCN = matrixResponseCNFull?.rows[0]?.elements[0]?.distance?.text;

        let duration = '';
        let distance = '';

        if (vehicle.Status !== 'ArrivedSite' && vehicle.Status !== 'SiteAccepted') {
          if (hkEqualsTwoLangs(geoDistrict)) {
            const matrixResponseHK = await matrixServiceHK.getDistanceMatrix(matrixRequestHK);

            duration = matrixResponseHK?.rows[0]?.elements[0]?.duration?.text;
            distance = matrixResponseHK?.rows[0]?.elements[0]?.distance?.text;
          }
          if (chinaEqualThreeLangs(geoDistrict)) {
            const matrixResponseCN = await matrixServiceCN.getDistanceMatrix(matrixRequestCNRoute);
            const matrixResponseHKFull = vehicle?.HongKong ? await matrixServiceHK.getDistanceMatrix(matrixRequestHKFullRoute) : '';

            const durationCN = matrixResponseCN?.rows[0]?.elements[0]?.duration?.value;
            const distanceCN = matrixResponseCN?.rows[0]?.elements[0]?.distance?.value;
            const durationHK = matrixResponseHKFull?.rows[0]?.elements[0]?.duration?.value;
            const distanceHK = matrixResponseHKFull?.rows[0]?.elements[0]?.distance?.value;

            duration = `${(durationCN + durationHK) / 60} mins`;
            distance = `${(distanceCN + distanceHK) / 1000} km`;
          }
        }
        return {
          // fullRouteCN: {
          //   duration: fullDurationCN,
          //   distance: fullDistanceCN
          // },
          // fullRouteHK: {
          //   duration: fullDurationHK,
          //   distance: fullDistanceHK
          // },
          geoAddress,
          geoDistrict,
          duration,
          distance
        };
      }

      return {};
    },
    [window.google?.maps]
  );

  const getVehicles = (deviceId) => {
    handleAsyncCall({
      service: realtimeMapService.getTVehicles,
      params: {
        projid: '629F9E29-0B36-4A9E-A2C4-C28969285583'
      },
      setDetailBlock: !deviceId ? setIsLoading : () => {},
      successCb: async (res) => {
        if (!_.isEmpty(res?.data)) {
          const resData = res?.data;

          if (resData.BatchList.findIndex((v) => v?.GpsDeviceId === deviceId) >= 0 || !deviceId) {
            setCount(resData?.BatchStatus ?? {});
            const tempVehicleList = [];
            setIsLoading(true);

            const fetchAndSet = async (vehicle) => {
              if (vehicle) {
                const distanceAndDuration = await fetchDistanceMatrix(vehicle);
                vehicle.distanceAndDuration = distanceAndDuration;
                tempVehicleList.push(vehicle);
              }
            };

            var limit = resData?.BatchList.length;

            for (var i = 0; i <= limit; i++) {
              await fetchAndSet(resData.BatchList[i]);

              // await new Promise((resolve) => {
              //   setTimeout(() => {
              //     resolve();
              //   }, 100);
              // });
            }

            setIsLoading(false);

            setVehicleList(tempVehicleList);
          }
          // setVehicleList((prev) => {
          //   if (!prev.find(({ RfidModuleId }) => RfidModuleId === vehicle.RfidModuleId)) {
          //     return [...prev, vehicle];
          //   }
          //   return prev;
          // });
          //
        }
      }
    });
  };

  useEffect(() => {
    if (window.google?.maps) {
      getVehicles();
    }
  }, [window.google?.maps]);

  useEffect(() => {
    const interval = setInterval(() => {
      getVehicles();
    }, 1000 * 15 * 60);
    return () => clearInterval(interval);
  }, []);

  const fetchDistanceService = async (tv, currLoc, currentDistrict) => {
    const chinaVehicleDirectionsService = new window.google.maps.DirectionsService();
    const hongKongVehicleDirectionsService = new window.google.maps.DirectionsService();

    // if current location is in china
    if (!_.isEmpty(tv?.China) && chinaEqualThreeLangs(currentDistrict)) {
      await chinaVehicleDirectionsService.route(
        {
          origin: {
            lat: tv?.China[0]?.lat,
            lng: tv?.China[0]?.lng
          },
          destination: { lat: currLoc.GpsLat, lng: currLoc.GpsLong },
          travelMode: window.google.maps.DirectionsTravelMode.DRIVING
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            setChinaStartToVehicleDirection(result);
          } else {
            console.error(`error fetching directions ${JSON.stringify(result)}`);
          }
        }
      );

      await chinaVehicleDirectionsService.route(
        {
          origin: { lat: currLoc.GpsLat, lng: currLoc.GpsLong },
          destination: {
            lat: tv?.China[1]?.lat,
            lng: tv?.China[1]?.lng
          },
          travelMode: window.google.maps.DirectionsTravelMode.DRIVING
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            setChinaVehicleToEndDirection(result);
          } else {
            console.error(`error fetching directions ${JSON.stringify(result)}`);
          }
        }
      );
      await hongKongVehicleDirectionsService.route(
        {
          origin: {
            lat: tv?.HongKong[0]?.lat,
            lng: tv?.HongKong[0]?.lng
          },
          destination: {
            lat: tv?.HongKong[1]?.lat,
            lng: tv?.HongKong[1]?.lng
          },
          travelMode: window.google.maps.DirectionsTravelMode.DRIVING
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            setHongKongStartToEndDirection(result);
          } else {
            console.error(`error fetching directions ${JSON.stringify(result)}`);
          }
        }
      );
    }

    // if current location is in hk
    if (!_.isEmpty(tv?.HongKong) && hkEqualsTwoLangs(currentDistrict)) {
      await chinaVehicleDirectionsService.route(
        {
          origin: {
            lat: tv?.China[0]?.lat,
            lng: tv?.China[0]?.lng
          },
          destination: {
            lat: tv?.China[1]?.lat,
            lng: tv?.China[1]?.lng
          },
          travelMode: window.google.maps.DirectionsTravelMode.DRIVING
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            setChinaStartToEndDirection(result);
          } else {
            console.error(`error fetching directions ${JSON.stringify(result)}`);
          }
        }
      );
      await hongKongVehicleDirectionsService.route(
        {
          origin: {
            lat: tv?.HongKong[0]?.lat,
            lng: tv?.HongKong[0]?.lng
          },
          destination: { lat: currLoc.GpsLat, lng: currLoc.GpsLong },
          travelMode: window.google.maps.DirectionsTravelMode.DRIVING
        },
        (result, status) => {
          if (status === window.google.maps.DirectionsStatus.OK) {
            setHongKongStartToVehicleDirection(result);
          } else {
            console.error(`error fetching directions ${JSON.stringify(result)}`);
          }
        }
      );

      if (tv?.Status !== 'ArrivedSite') {
        await hongKongVehicleDirectionsService.route(
          {
            origin: { lat: currLoc.GpsLat, lng: currLoc.GpsLong },
            destination: {
              lat: tv?.HongKong[1]?.lat,
              lng: tv?.HongKong[1]?.lng
            },
            travelMode: window.google.maps.DirectionsTravelMode.DRIVING
          },
          (result, status) => {
            if (status === window.google.maps.DirectionsStatus.OK) {
              setHongKongVehicleToEndDirection(result);
            } else {
              console.error(`error fetching directions ${JSON.stringify(result)}`);
            }
          }
        );
      }
    }
  };
  useEffect(() => {
    dispatch(rFetchWorkflows());
  }, []);

  useEffect(() => {
    if (window.google?.maps && !_.isEmpty(vehicleList)) {
      const pusher = new Pusher(process.env.REACT_APP_PUSHER_KEY, {
        cluster: 'ap1',
        encrypted: true
      });
      const channel = pusher.subscribe('my-channel');
      channel.bind('my-event', (data) => {
        // setPusherState(data)
        const gpsLat = Object.values(data.message.gps_lat);
        const gpsLong = Object.values(data.message.gps_long);

        if (!_.isEmpty(vehicleList) && vehicleList.findIndex((v) => v?.GpsDeviceId === data.message?.deviceId) < 0) {
          getVehicles(data.message?.deviceId);
        } else if (targetVehicle?.GpsDeviceId === data.message?.deviceId) {
          setCurrentLocation({
            GpsLat: Number(gpsLat[0]),
            GpsLong: Number(gpsLong[0]),
            TimeStamp: data.message.timestamp
          });
        }

        // if (!_.isEmpty(targetVehicle) && !_.isEmpty(gpsLat) && targetVehicle?.GpsDeviceId === data.message?.deviceId) {
        //   channel.unbind('my-event');

        // }
      });

      return () => channel.unbind('my-event');
    }
  }, [window.google?.maps, vehicleList, targetVehicle]);

  useEffect(() => {
    const fetchDM = async () => {
      const distanceAndDuration = await fetchDistanceMatrix({
        ...targetVehicle,
        CurrentLocation: {
          GpsLat: currentLocation?.GpsLat,
          GpsLong: currentLocation?.GpsLong
        }
      });

      setTargetVehicle({
        ...targetVehicle,
        distanceAndDuration,
        CurrentLocation: {
          GpsLat: currentLocation?.GpsLat,
          GpsLong: currentLocation?.GpsLong,
          TimeStamp: currentLocation.TimeStamp
        }
      });
    };
    if (window.google?.maps && targetVehicle?.BatchNo && currentLocation?.GpsLat) {
      fetchDistanceService(targetVehicle, currentLocation, currentDistrict);
      fetchDM();
      setMapCenter({
        lat: currentLocation?.GpsLat,
        lng: currentLocation?.GpsLong
      });
    }
  }, [targetVehicle?.BatchNo, currentLocation?.GpsLat, window.google?.maps]);

  return {
    chinaStartToVehicleDirection,
    setChinaStartToVehicleDirection,
    chinaVehicleToEndDirection,
    setChinaVehicleToEndDirection,
    hongKongStartToEndDirection,
    setHongKongStartToEndDirection,
    chinaStartToEndDirection,
    setChinaStartToEndDirection,
    hongKongStartToVehicleDirection,
    setHongKongStartToVehicleDirection,
    hongKongVehicleToEndDirection,
    setHongKongVehicleToEndDirection,
    currentVehicleHistories,
    setCurrentDistrict,
    handleChange,
    mapRef,
    upperCaseLang,
    value,
    setValue,
    targetVehicle,
    openVehicleList,
    setOpenVehicleList,
    mapCenter,
    isLoaded,
    isLoading,
    vehicleList,
    workflows,
    setTargetVehicle,
    currentLocation,
    count,
    setCurrentLocation,
    setCurrentVehicleHistories
  };
};
